import React from 'react'
import { MdOutlineClose } from 'react-icons/md';
import BackButton from '../UI/BackButton';
import Button from '../UI/Button';
import { useState } from 'react';
import { useRef } from 'react';
import { MdAddCircleOutline } from 'react-icons/md';
import { LuFileCheck2 } from 'react-icons/lu';
import { HiOutlineTrash } from 'react-icons/hi2';

const ItineraryModal = ({ isOpen, closeModal, setFormData }) => {
  const MAX_FILES = 10;
  const inputRef = useRef(null);
  const [chosenFile, setChosenFile] = useState(null);
  const [error, setError] = useState(false);
  const handleFileEvent = (e) => {
    console.log("fired");
    const file = e.target.files[0]
    const allowedTypes = ["application/pdf"]; // Define allowed types
    if (!allowedTypes.includes(file.type)) {
      setError(true)
      return false;
    }
    handleUploadFiles(file);
  };

  const handleUploadFiles = (files) => {
    setChosenFile(files);
    // setCounter(counter + 1);
  };

  if (!isOpen) return null;
  return (
    <div
      class="relative z-20"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        aria-hidden="true"
      ></div>

      <div class="fixed inset-0 z-10 w-screen h-[90vh]">
        <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div class="relative max-h-[90vh] overflow-auto w-full transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div class="bg-white rounded-lg px-4 md:px-2 pb-2 pt-5 sm:p-6 sm:pb-4">
              <div class="flex flex-col gap-4 px-4 cursor-pointer">
                <div className="flex gap-8 items-center justify-between">
                  <h2 className="text-2xl md:text-3xl font-bold">
                    Choose Event PDF
                  </h2>
                  <MdOutlineClose
                    size={25}
                    onClick={closeModal}
                    className=" text-gray-500 cursor-pointer"
                  />
                </div>
                <div
                  onClick={() => {
                    inputRef.current.click();
                  }}
                  className="flex flex-col py-8 rounded-xl items-center justify-center border border-[#dad3c3] border-dashed"
                >
                  <MdAddCircleOutline
                    size={25}
                    className=" text-gray-500 cursor-pointer mb-2"
                  />
                  {chosenFile ? <h2 className="text-lg text-black font-semibold">
                    Click to change
                  </h2> : <h2 className="text-lg text-black font-semibold">
                    Click to upload
                  </h2>}
                  <input
                    onChange={handleFileEvent}
                    id="fileUpload"
                    type="file"
                    className="hidden"
                    accept="application/pdf"
                    ref={inputRef}
                  />
                  <span className="text-gray-500 text-sm">
                    Supported formats: .pdf
                  </span>
                  {error && <span>Please select .pdf file</span>}
                </div>
              </div>
            </div>
            {
              chosenFile && (
                <div className="flex items-center justify-between px-4 py-2 bg-gray-100 rounded-lg mx-8 my-2 md:mx-6">
                  <div className="flex items-center gap-2">
                    <LuFileCheck2 size={20} />
                    <h4 className="text-[14px] font-medium">{chosenFile.name}</h4>
                  </div>
                  <HiOutlineTrash className='cursor-pointer' size={20} onClick={() => setChosenFile(null)} />
                </div>
              )
            }

            <hr className="my-2 h-[1px] border-none bg-black opacity-30" />
            <div className="flex justify-between px-4 py-3">
              {/* <button
                  type="button"
                  onClick={() => {
                    setChosenFiles([]);
                    closeModal();
                  }}
                  className=" bg-white border-[1px] font-semibold border-black border-opacity-40 px-10 py-1 text-black rounded-lg"
                >
                  Cancel
                </button> */}
              <BackButton
                text={"Cancel"}
                handleClick={() => {
                  setChosenFile(null);
                  closeModal();
                }}
              ></BackButton>
              {/* <button
                  type="button"
                  className="text-white bg-[#4F55DA] font-medium px-10 py-1 my-0 rounded-lg"
                  onClick={() => {
                    setEventImages((prev) => [...prev, ...chosenFiles]);
                    setChosenFiles([]);
                    closeModal();
                  }}
                >
                  Done
                </button> */}
              <Button text={"Done"} handleClick={() => {
                setFormData((prev) => ({ ...prev, host_event_pdf_file: chosenFile }));
                setChosenFile([]);
                closeModal();
              }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItineraryModal


export const FeedbackDocModal = ({ isOpen, closeModal, setFormData, setFeedbackDoc }) => {
  const MAX_FILES = 10;
  const inputRef = useRef(null);
  const [chosenFile, setChosenFile] = useState(null);
  const [error, setError] = useState(false);
  const handleFileEvent = (e) => {
    console.log("fired");
    const file = e.target.files[0]
    const allowedTypes = ["application/pdf"]; // Define allowed types
    if (!allowedTypes.includes(file.type)) {
      setError(true)
      return false;
    }
    handleUploadFiles(file);
  };

  const handleUploadFiles = (files) => {
    setChosenFile(files);
    setFeedbackDoc(files);
    // setCounter(counter + 1);
  };

  if (!isOpen) return null;
  return (
    <div
      class="relative z-20"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        aria-hidden="true"
      ></div>

      <div class="fixed inset-0 z-10 w-screen h-[90vh]">
        <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div class="relative max-h-[90vh] overflow-auto w-full transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div class="bg-white rounded-lg px-4 md:px-2 pb-2 pt-5 sm:p-6 sm:pb-4">
              <div class="flex flex-col gap-4 px-4 cursor-pointer">
                <div className="flex gap-8 items-center justify-between">
                  <h2 className="text-2xl md:text-3xl font-bold">
                    Choose Feedback Document
                  </h2>
                  <MdOutlineClose
                    size={25}
                    onClick={closeModal}
                    className=" text-gray-500 cursor-pointer"
                  />
                </div>
                <div
                  onClick={() => {
                    inputRef.current.click();
                  }}
                  className="flex flex-col py-8 rounded-xl items-center justify-center border border-[#dad3c3] border-dashed"
                >
                  <MdAddCircleOutline
                    size={25}
                    className=" text-gray-500 cursor-pointer mb-2"
                  />
                  {chosenFile ? <h2 className="text-lg text-black font-semibold">
                    Click to change
                  </h2> : <h2 className="text-lg text-black font-semibold">
                    Click to upload
                  </h2>}
                  <input
                    onChange={handleFileEvent}
                    id="fileUpload"
                    type="file"
                    className="hidden"
                    accept="application/pdf"
                    ref={inputRef}
                  />
                  <span className="text-gray-500 text-sm">
                    Supported formats: .pdf
                  </span>
                  {error && <span>Please select .pdf file</span>}
                </div>
              </div>
            </div>
            {
              chosenFile && (
                <div className="flex items-center justify-between px-4 py-2 bg-gray-100 rounded-lg mx-8 my-2 md:mx-6">
                  <div className="flex items-center gap-2">
                    <LuFileCheck2 size={20} />
                    <h4 className="text-[14px] font-medium">{chosenFile.name}</h4>
                  </div>
                  <HiOutlineTrash className='cursor-pointer' size={20} onClick={() => setChosenFile(null)} />
                </div>
              )
            }

            <hr className="my-2 h-[1px] border-none bg-black opacity-30" />
            <div className="flex justify-between px-4 py-3">
              {/* <button
                  type="button"
                  onClick={() => {
                    setChosenFiles([]);
                    closeModal();
                  }}
                  className=" bg-white border-[1px] font-semibold border-black border-opacity-40 px-10 py-1 text-black rounded-lg"
                >
                  Cancel
                </button> */}
              <BackButton
                text={"Cancel"}
                handleClick={() => {
                  setChosenFile(null);
                  closeModal();
                }}
              ></BackButton>
              {/* <button
                  type="button"
                  className="text-white bg-[#4F55DA] font-medium px-10 py-1 my-0 rounded-lg"
                  onClick={() => {
                    setEventImages((prev) => [...prev, ...chosenFiles]);
                    setChosenFiles([]);
                    closeModal();
                  }}
                >
                  Done
                </button> */}
              <Button text={"Done"} handleClick={() => {
                setFormData((prev) => ({ ...prev, feedbackDoc: chosenFile.name }));
                setFeedbackDoc(chosenFile);
                setChosenFile([]);
                closeModal();
              }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}